import { updatePricingBaseRequest } from "../../data/pricingBaseApi";
import { validatePricingBasePayload } from "../validator/validatePricingBasePayload";

export async function updatePricingBaseUseCase(payload) {
  if (!payload?.id) {
    throw new Error("El id es obligatorio.");
  }

  const error = validatePricingBasePayload(payload);

  if (error) {
    throw new Error(error);
  }

  return await updatePricingBaseRequest(payload);
}
